import { extendTheme } from "@chakra-ui/react"

const theme = extendTheme({
  variants: {
    outline: {
      bg: "none",
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "primary.black.100",
      display: "flex",
      alignItems: "center",
      gap: 2,
      outline: "none",
      textDecoration: "none !important",
      _hover: {
        bg: "primary.black.100",
        color: "primary.white.100",
      },
    },
    black: {
      bg: "primary.black.100",
      display: "flex",
      alignItems: "center",
      gap: 2,
      outline: "none",
      color: "primary.white.100",
      textDecoration: "none !important",
      _hover: {
        bg: "primary.black.90",
      },
    },
  },
  sizes: {
    medium: {
      padding: "8px 16px",
      rounded: "40px",
      fontSize: "16px",
      fontWeight: 500,
      fontFamily: "riforma.medium",
      lineHeight: "24px",
      letterSpacing: "0.16px",
    },
    large: {
      padding: "16px 32px",
      rounded: "40px",
      fontSize: "20px",
      fontWeight: 500,
      fontFamily: "riforma.medium",
      lineHeight: "32px",
    },
  },
})

export default theme
